import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import LogoOne from "../../../assets/images/logo.png";
import SetupPasswordForm from './SetupPasswordForm';

// Routed at /setup-password?token=... — the token is issued by EmailVerificationController.verify()
// and carried here via the redirect from EmailVerifyPage on successful email verification.
// Layout mirrors ResetPasswordPage exactly (same Card structure, same logo, same copyright line).
const SetupPasswordPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Container fluid>
        <Row>
          <Col
            style={{ position: 'relative', marginTop: '100px' }}
            className='p-0 col-4 form-login'
          >
            <div className='login-wrap'>
              <Card className='h-100 pt-4 pb-5 p-4'>
                <img src={LogoOne} className='logoWidth pb-5' />
                <Card.Header className='cardHeader textLowerCase'>
                  {t('resource_2:setupPassword', 'Set Up Password')}
                </Card.Header>
                <Card.Body className='p-2 bodyHeightReset'>
                  <SetupPasswordForm />
                </Card.Body>
                <div className='col-12 fs--1 copyWriteText'>
                  Copyright © EA Technologies 2025. All rights reserved
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SetupPasswordPage;
